import {
  SURVEY_TYPES,
  SURVEY_TYPE_LABELS,
  MAX_NESTING_LEVEL,
  CHILD_QUESTION_TYPES,
  NESTED_HIGHLIGHT_STYLES
} from "../constants/constantsSurveys";

export { MAX_NESTING_LEVEL, CHILD_QUESTION_TYPES };

export const TYPE_LABEL_MAP = SURVEY_TYPE_LABELS;

export const isSingleChoice = (type) => type === SURVEY_TYPES.singleChoice;

export const isMultipleChoice = (type) => type === SURVEY_TYPES.multipleChoice;

export const isImageType = (type) => type === SURVEY_TYPES.image;

export const supportsOptions = (type) => {
  return type === SURVEY_TYPES.singleChoice || type === SURVEY_TYPES.multipleChoice;
};

export const isDefaultOptionLabel = (label, index) => {
  return (label || "").trim() === `Opción ${index + 1}`;
};

export const buildEmptyOption = () => ({
  id: crypto.randomUUID(),
  label: "",
  childQuestions: []
});

export const buildDefaultOptionsByType = (type) => {
  if (supportsOptions(type)) {
    return [buildEmptyOption(), buildEmptyOption()];
  }

  return [];
};

export const buildChildQuestion = (type, level = 2, displayIndex = "1.1") => ({
  id: crypto.randomUUID(),
  uid: crypto.randomUUID(),
  type,
  title: "",
  description: "",
  level,
  displayIndex,
  isConditionalParent: false,
  requiredImage: isImageType(type),
  options: buildDefaultOptionsByType(type),
  shouldValidate: false
});

export const canAddConditionalToQuestion = (question) => {
  const level = question.level || 1;
  return isSingleChoice(question.type) && level < MAX_NESTING_LEVEL;
};

export const questionHasNestedChildren = (question) => {
  return (question.options || []).some(
    (option) => (option.childQuestions || []).length > 0
  );
};

export const normalizeQuestionTreeDisplayIndexes = (
  question,
  newDisplayIndex
) => {
  const normalizedOptions = (question.options || []).map((option, optionIndex) => ({
    ...option,
    childQuestions: (option.childQuestions || []).map((childQuestion) => {
      const childDisplayIndex = `${newDisplayIndex}.${optionIndex + 1}`;

      return normalizeQuestionTreeDisplayIndexes(
        childQuestion,
        childDisplayIndex
      );
    })
  }));

  return {
    ...question,
    displayIndex: newDisplayIndex,
    options: normalizedOptions
  };
};

export const normalizeChildrenDisplayIndexes = (
  options = [],
  parentDisplayIndex
) => {
  return options.map((option, optionIndex) => ({
    ...option,
    childQuestions: (option.childQuestions || []).map((childQuestion) => {
      const childDisplayIndex = `${parentDisplayIndex}.${optionIndex + 1}`;

      return normalizeQuestionTreeDisplayIndexes(
        childQuestion,
        childDisplayIndex
      );
    })
  }));
};

export const shouldHighlightSingleChoiceCard = (question) => {
  return isSingleChoice(question?.type) && Boolean(question?.isConditionalParent);
};

export const shouldUseOrangeForNestedQuestion = (question) => {
  return isSingleChoice(question?.type) && Boolean(question?.isConditionalParent);
};

export const getNestedAppearanceProps = (question) => {
  if (!shouldUseOrangeForNestedQuestion(question)) {
    return {};
  }

  return NESTED_HIGHLIGHT_STYLES;
};